import { render, staticRenderFns } from "./prognosis.vue?vue&type=template&id=0661d237&scoped=true"
import script from "./prognosis.vue?vue&type=script&lang=js"
export * from "./prognosis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0661d237",
  null
  
)

export default component.exports